import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/status-invitation';

class StatusService extends ServiceBase {
  constructor() {
    super({ resource });
  }
}

export default StatusService;



// WEBPACK FOOTER //
// ./src/services/StatusService.js